import { h, Component } from "preact";
import _ from "underscore";

const Fragment = ({ children }) => <span>{children}</span>;

function translate(txt,lang) {
  const translations = {
    lv:{},
    en:{
      "Tālrunis" : "Phone",
      "E-pasts" : "E-mail",
      "Fakss" : "Fax",
      "Reģ.Nr." : "Reg.No.",
      "Adrese" : "Address",
      "Mājas lapa" : "Website",
      "/lv/karte" : "/en/map",
      "Aplūkot uz kartes" : "View on map",
      "Visiem" : "All",
      "Visas kravas" : "All cargo",
      "Visi servisi" : "All services",
      "Mob.numurs": "Mob.Phone",
    },
    ru:{
      "Tālrunis" : "Телефон",
      "E-pasts" : "Эл.почта",
      "Fakss" : "Факс",
      "Reģ.Nr." : "Рег.номер",
      "Adrese" : "Адрес",
      "Mājas lapa" : "Веб-сайт",
      "/lv/karte" : "/ru/karta",
      "Aplūkot uz kartes" : "Посмотреть на карте",
      "Visiem" : "Все",
      "Visas kravas" : "Все грузы",
      "Visi servisi" : "Все услуги",
      "Mob.numurs": "Моб.телефон"
    },
  }
  if (translations[lang] && translations[lang][txt]) return translations[lang][txt];
  else return txt;
}

const servicesMap = {};
function Company(props) {
  return (
    <Fragment>
      {props.field_image && (
        <div class="logo">
          <img src={props.field_image} alt="" />
        </div>
      )}
      <div class="title">{props.title}</div>
      <dl>
        {props.field_talrunis && (
          <Fragment>
            <dt>{translate('Tālrunis',props.language)}:</dt>
            <dd>{props.field_talrunis}</dd>
          </Fragment>
        )}
        {props.field_mob_numurs && (
          <Fragment>
            <dt>{translate('Mob.numurs',props.language)}:</dt>
            <dd>{props.field_mob_numurs}</dd>
          </Fragment>
        )}
        {props.field_e_pasts && (
          <Fragment>
            <dt>{translate('E-pasts',props.language)}:</dt>
            <dd>{props.field_e_pasts}</dd>
          </Fragment>
        )}
        {props.field_fakss && (
          <Fragment>
            <dt>{translate('Fakss',props.language)}:</dt>
            <dd>{props.field_fakss}</dd>
          </Fragment>
        )}
        {props.field_registracijas_nr_ && (
          <Fragment>
            <dt>{translate('Reģ.Nr.',props.language)}:</dt>
            <dd>{props.field_registracijas_nr_}</dd>
          </Fragment>
        )}
        {props.field_adrese && (
          <Fragment>
            <dt>{translate('Adrese',props.language)}:</dt>
            <dd>
              {[
                props.field_adrese,
                props.field_pilseta,
                props.field_pasta_indekss,
              ].join(", ")}
              {props.field_valsts &&
                props.field_valsts !== "Latvija" &&
                ", " + props.field_valsts}
            </dd>
          </Fragment>
        )}
        {props.field_majas_lapa && (
          <Fragment>
            <dt>{translate('Mājas lapa',props.language)}:</dt>
            <dd>
              <a href={props.field_majas_lapa} target="_blank">
                {props.field_majas_lapa}
              </a>
            </dd>
          </Fragment>
        )}
      </dl>
      <div class="company-body">
        <span
          dangerouslySetInnerHTML={{
            __html: props.body,
          }}
        />
        <ul class="tags">
          {props.field_pakalpojumi
            .filter((s) => s && servicesMap[s] && servicesMap[s].name)
            .map((s, key) => (
              <li key={key}>
                <a href="javascript:">{servicesMap[s].name}</a>
              </li>
            ))}
        </ul>
        {props.loc && (
          <a
            href={
              (translate('/lv/karte',props.language)) +
              "?n=" +
              props.nid +
              "&l=" +
              props.loc.join(",")
            }
            target="_blank"
            class="button red"
          >
            {translate('Aplūkot uz kartes',props.language)}
          </a>
        )}
      </div>
    </Fragment>
  );
}
export default class App extends Component {
  state = {
    level1: null,
    level2: null,
    level3: null,
    companies: [],
    loading: true,
  };
  async componentWillMount() {
    this.state.services = this.props.services
      .map((s) => ({
        ...s,
        tid: s.tid | 0,
        parents: s.parents.map((p) => p | 0),
      }))
      .map((s) => (servicesMap[s.tid] ? undefined : (servicesMap[s.tid] = s)))
      .filter((s) => !!s);

    await this.fetchCompanies();
    if (location.search) {
      const values =
        location.search
          .split("&")
          .map((el) => el.split("="))
          .filter((el) => el[0] === "?pakalpojumi" || el[0] === "?t")
          .map((el) => el[1])
          .join("") | 0;
      console.log("srv", values);
      if (servicesMap[values]) {
        if (servicesMap[values].depth === 0) {
          this.state.level1 = servicesMap[values].tid;
        } else if (servicesMap[values].depth === 1) {
          this.state.level1 = servicesMap[values].parents[0];
          this.state.level2 = servicesMap[values].tid;
        }
      }
    }
  }
  fetchCompanies(tid) {
    const { props } = this;
    this.setState({ loading: true });
    return fetch(
      "/" +
        props.language +
        "/api/v1/companies" +
        (tid ? "?service=" + tid : "")
    ).then((res) => {
      //
      res.json().then((json) => {
        const companies = json
          .map((company) => ({
            ...company,
            title: _.unescape(company.title),
            field_adrese: _.unescape(company.field_adrese),
            nid: company.nid | 0,
            field_pakalpojumi: company.field_pakalpojumi
              .split(",")
              .map((s) => s | 0),
            services: company.field_pakalpojumi.split(",").map((s) => s | 0),
            loc:
              company.field_atrasanas_vieta !== "POINT (0 0)"
                ? Array.from(
                    ("" + company.field_atrasanas_vieta).matchAll(
                      /[^(]*\(([\d\.]*)\ ([\d\.]*)\)/g
                    ),
                    (m) => [m[1] * 1.0, m[2] * 1.0]
                  )[0]
                : undefined,
          }))
          .sort((a, b) => {
            if (typeof a.title === "string") {
              return (
                a.title.localeCompare(b.title, "lv", {
                  ignorePunctuation: true,
                }) * 1
              );
            }
            return (a.title > b.title ? 1 : -1) * 1;
          });
        for (let company of companies) {
          for (let pak of company.field_pakalpojumi) {
            if (servicesMap[pak] && servicesMap[pak].depth > 0) {
              company.services.push(servicesMap[pak].parents[0]);
            }
          }
        }
        this.setState({ loading: false, companies });
      });
      //
    });
  }
  render(props, state) {
    let { services } = state;
    const services3 = services.filter(
      (service) =>
        service.depth === 2 &&
        (state.level2 === null || service.parents.includes(state.level2))
    );

    let parent = undefined;
    if (this.state.level1) parent = this.state.level1;
    if (this.state.level2) parent = this.state.level2;
    if (this.state.level3) parent = this.state.level3;
    const companies = this.state.companies.filter(
      (company) =>
        !parent || (company.services && company.services.includes(parent))
    );
    console.log("state", state);
    return (
      <div>
        <div class="container">
          <div class="page-header">
            <h1>{props.title}</h1>
            <ul class="items-filter service-categories top-gap">
              <li
                class={"all " + (this.state.level1 === null ? "active" : "")}
                onClick={() =>
                  this.setState({ level1: null, level2: null, level3: null })
                }
              >
                {translate('Visiem',props.language)}
              </li>
              {services
                .filter((service) => service.depth == 0)
                .map((service) => (
                  <li
                    onClick={() =>
                      this.setState({
                        level1: service.tid,
                        level2: null,
                        level3: null,
                      })
                    }
                    class={[
                      service.icon ? service.icon : "",
                      this.state.level1 == service.tid ? "active" : "",
                    ].join(" ")}
                  >
                    {service.name}
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div class="items-filter-wrapper">
          <div class="container">
            <ul class="items-filter">
              <li
                class={this.state.level2 === null ? "active" : ""}
                onClick={() => this.setState({ level2: null, level3: null })}
              >
                {translate('Visi servisi',props.language)}
              </li>
              {services
                .filter(
                  (service) =>
                    service.depth === 1 &&
                    (state.level1 === null ||
                      service.parents.includes(state.level1))
                )
                .map((service) => (
                  <li
                    onClick={() =>
                      this.setState({ level2: service.tid, level3: null })
                    }
                    class={[
                      service.icon ? service.icon : "",
                      this.state.level2 == service.tid ? "active" : "",
                    ].join(" ")}
                  >
                    {service.name}
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div class="container">
          {services3 && !!services3.length && state.level1 == 54 && (
            <ul class="items-filter">
              {/* <li>Visas kravas</li> */}
              <li
                class={this.state.level3 === null ? "active" : ""}
                onClick={() => this.setState({ level3: null })}
              >
                {translate('Visas kravas',props.language)}
              </li>
              {services3.map((service) => (
                <li
                  onClick={() => this.setState({ level3: service.tid })}
                  class={[
                    service.icon ? service.icon : "",
                    this.state.level3 == service.tid ? "active" : "",
                  ].join(" ")}
                >
                  {service.name}
                </li>
              ))}
            </ul>
          )}
          {!this.state.loading && !!this.state.companies.length && (
            <div class="content-area">
              <ul class="services column">
                {companies
                  .filter((c, i) => i % 2 == 0)
                  .map((c) => (
                    <li key={c.nid}>
                      <Company {...c} language={this.props.language} />
                    </li>
                  ))}
              </ul>
              <ul class="services column">
                {companies
                  .filter((c, i) => i % 2 == 1)
                  .map((c) => (
                    <li key={c.nid}>
                      <Company {...c} language={this.props.language} />
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  }
}
